import { ChatWaitlistBanner } from 'components/core';
import BannerMovementPreview from 'components/core/PreviewBanner/PreviewBanner';
import { useLocation } from 'react-router-dom';
import {
  CHAT_WAITLIST_STATUS,
  JOIN_WAITLIST_URL,
  WaitlistStatus,
} from 'utils/constants/Chat';
import { MOVEMENT_DASHBOARD_PATH } from 'utils/constants/Preview';
import { usePermissions } from 'utils/hooks';

import { CarrierWelcomeBanner } from '@project44/shared-components';
import { useLocalStorage, useUser } from '@project44/ui-utils';

function PageBanner() {
  const {
    flags: { featureNx726 },
    permissions: { canViewChat },
  } = usePermissions();
  const { data: user } = useUser({ skipRedirectOn401: true });
  const currentLocation = useLocation().pathname;

  const [welcomeBannerVisible, setWelcomeBannerVisible] =
    useLocalStorage<boolean>({
      namespace: null, // Also used by other webapps
      key: 'show-carrier-welcome-banner',
      defaultValue: true,
    });

  const [waitlistStatus, setWaitlistStatus] = useLocalStorage<WaitlistStatus>({
    namespace: null, // For retro-compatibility
    key: CHAT_WAITLIST_STATUS,
    defaultValue: WaitlistStatus.PENDING_JOIN,
  });

  const isCarrierTenant = user?.tenantCarrierNetworkRoles.includes('CARRIER');
  const showWelcomeBanner = featureNx726 && isCarrierTenant;
  const showWaitlistBanner = [
    WaitlistStatus.PENDING_JOIN,
    WaitlistStatus.PENDING_GRANTED,
  ].includes(waitlistStatus);

  const showMovementPreviewBanner =
    user?.customerProperties?.ENABLE_MOVEMENT_SELF_PREVIEW == true &&
    currentLocation === MOVEMENT_DASHBOARD_PATH;

  if (showWelcomeBanner && welcomeBannerVisible) {
    return (
      <CarrierWelcomeBanner onClose={() => setWelcomeBannerVisible(false)} />
    );
  }
  if (
    !canViewChat &&
    !showWelcomeBanner &&
    !showMovementPreviewBanner &&
    showWaitlistBanner
  ) {
    return (
      <ChatWaitlistBanner
        status={waitlistStatus}
        onClose={() => setWaitlistStatus(WaitlistStatus.CLOSED)}
        onJoin={() => {
          setWaitlistStatus(WaitlistStatus.PENDING_GRANTED);
          window.open(JOIN_WAITLIST_URL, '_blank');
        }}
      />
    );
  }

  if (showMovementPreviewBanner) {
    return <BannerMovementPreview />;
  }

  return null;
}

export default PageBanner;
